import { Button } from '@shoflo/polymer/components/Button/Button';
import styled, { css } from 'styled-components';

const isOutlined = css`
  background: #ffffff;
  border: 1px solid #dfe3ec;
`;

const alignLeft = css`
  margin: 0 auto 0 0 !important;
`;

const shared = css`
  font-weight: normal;
  ${({ outline }) => outline && isOutlined};
  ${({ left }) => left && alignLeft}
`;

const sharedMargin = css`
  margin: 0 0 0 8px !important;
`;

export const StyledModalConfirmButton = styled(Button)`
  margin: ${({ noRightMargin }) =>
    noRightMargin ? 0 : '0 8px 0 0 !important'};
  ${shared};
`;

export const StyledModalCancelButton = styled(Button).attrs(({ outline }) => ({
  color: 'secondary',
  variant: { outline } ? 'outlined' : undefined,
}))`
  ${sharedMargin};
  ${shared};
`;

export const StyledModalKeepPlanButton = styled(Button)`
  ${sharedMargin};
  ${shared};
  color: #33373d;
`;

export default {
  StyledModalConfirmButton,
  StyledModalCancelButton,
  StyledModalKeepPlanButton,
};
